import { OnboardingAddressLogic } from "./logic";
import { OnboardingAddressTemplate } from "./template";

export const OnboardingAddressPage = (): JSX.Element => {
  const props = OnboardingAddressLogic();
  return <OnboardingAddressTemplate {...props} />;
}; 